export const DBVARIANT = {
	PATH: "/db/",
	CONSTRUCTION_STAGE_CHECK : "STLD",
	CONSTRUCTION_STAGE : "STCT",
	LOAD_COMBINATION: "LCOM-GEN",
	MOVING_LOAD: "MVLD",
	MOVING_LOAD_VARIANT: "MVCD",
	SETTLEMENT: "SMLC",
	RESPONSE_SPECTRUM: "SPLC",
	TIME_HISTORY: "THIS",
	STATIC_LOAD: "STLD",
}